module.exports = __webpack_public_path__ + "img/74989e7c-652e-4ef8-9ee3-c4b2590afbb6.8d295b01.jpg";